import {
  SectionElement,
  defineElement,
  onClick,
  queryAll
} from "./chunk-POAMU4SL.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/common-description/common-description.ts
var CommonDescription = class extends SectionElement {
  handleOpenButtonClick(elm) {
    const index = parseInt(elm.dataset.title);
    this.texts.forEach((text) => {
      text.dataset.text === index.toString() ? text.classList.remove("hidden") : text.classList.add("hidden");
    });
    this.titles.forEach((title) => {
      title.dataset.title === index.toString() ? title.classList.add("!border-gray-700") : title.classList.remove("!border-gray-700");
    });
    this.titles.forEach(
      (title) => {
        title.dataset.title === index.toString() ? title.firstElementChild.classList.add("!text-gray-800") : title.firstElementChild.classList.remove("!text-gray-800");
      }
    );
  }
  handleAccordionClick(elm) {
    const index = parseInt(elm.dataset.openButton);
    if (this.accordions[index].isOpen) {
      this.close(index);
    } else {
      this.closeAll();
      this.open(index);
    }
  }
  open(index) {
    this.accordions[index].open();
    this.chevrons[index].classList.add("rotate-180");
  }
  close(index) {
    this.accordions[index].close();
    this.chevrons[index].classList.remove("rotate-180");
  }
  closeAll() {
    this.accordions.forEach((accordion, index) => {
      this.close(index);
    });
  }
  connectedCallback() {
    return __async(this, null, function* () {
      this.open(0);
    });
  }
};
__decorateClass([
  queryAll("[data-text]")
], CommonDescription.prototype, "texts", 2);
__decorateClass([
  queryAll("[data-title]")
], CommonDescription.prototype, "titles", 2);
__decorateClass([
  onClick("[data-title]")
], CommonDescription.prototype, "handleOpenButtonClick", 1);
__decorateClass([
  queryAll("[data-accordion]")
], CommonDescription.prototype, "accordions", 2);
__decorateClass([
  queryAll("[data-chevron]")
], CommonDescription.prototype, "chevrons", 2);
__decorateClass([
  onClick("[data-open-button]")
], CommonDescription.prototype, "handleAccordionClick", 1);
CommonDescription = __decorateClass([
  defineElement("common-description")
], CommonDescription);
export {
  CommonDescription
};
